// extracted by mini-css-extract-plugin
export default {"container":"Lo-z","brandName":"Mo-z","productName":"No-z","productNamePdpEnhancements":"Oo-z","breakLongProductName":"Po-z"};